import { render } from "./ParentAdd.vue?vue&type=template&id=6f4dc5c7&scoped=true&ts=true"
import script from "./ParentAdd.vue?vue&type=script&lang=ts"
export * from "./ParentAdd.vue?vue&type=script&lang=ts"

import "./ParentAdd.vue?vue&type=style&index=0&id=6f4dc5c7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4dc5c7"]])

export default __exports__